import { FunctionComponent } from 'react';

import styles from './ScreenshotIntro.module.sass';
import { CompanyCDN } from '../../../utils/url';

const ScreenshotIntro: FunctionComponent = () => {
    return (
        // <div className={styles.container}>
        //     <div className={styles.screenshot}>
        //         <img
        //             src={CompanyCDN.url('/assets/images/about-ra-shopify/widget.png')}
        //             style={{ width: '100%' }}
        //             alt="Screenshot"
        //         />
        //     </div>
        //     <div className={styles.intro}>
        //         <div className={styles.introTitle}>Seel Return Assurance</div>
        //         <div className={styles.introContent}>
        //             Have you ever hesitated buying an item because the return policy said no returns
        //             or refunds? With Seel Return Assurance, you can receive a refund for otherwise
        //             non-refundable items. Simply add Seel Return Assurance to your order during
        //             checkout to have the option to return your items and receive a refund.
        //         </div>
        //     </div>
        // </div>
        <div className={styles.container}>
            <div className={styles.screenshot}>
                <img
                    src={CompanyCDN.url('/assets/images/about-ra/widget.png')}
                    style={{ width: '100%' }}
                    alt="Screenshot"
                />
            </div>
            <div className={styles.intro}>
                <div className={styles.introTitle}>Seel Return Assurance</div>
                <div className={styles.introContent}>
                    Have you ever hesitated buying an item because the return policy said no returns
                    or refunds? With Seel Return Assurance, you can receive a refund for otherwise
                    non-refundable items. Simply add Seel Return Assurance to your order during
                    checkout to have the option to return your items and receive a refund.
                </div>
            </div>
        </div>
    );
};

export default ScreenshotIntro;
